/* eslint-disable complexity */
import { captureException } from '@sentry/node';

import { doRequest } from '@r1-frontend/do-request/index';
import { IRegPayCard } from '@r1-frontend/api-domru/api-pay/v1/card/dto/IRegPayCard';
import { makePaymentAuth, makePaymentUnauth } from '@r1-frontend/api-domru/api-pay/v1/payment/add';

import { selectCardPaySum } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/selectors/selectPaymentSum';
import { TAppThunkDispatch, TGetState } from '~/src/store';

import { IPaymentResult, setPaymentResult } from '../actionCreators';

export interface INewCardPayment {
    _agreement?: string,
    _agreementEnc?: string,
    deliveryRequestId?: string,
}

interface IAuthRequestParams {
    save_card_flag: number,
    autopay_act: number,
    email: string,
    delivery_request_id?: string,
}

interface IUnauthRequestParams {
    agreement_enc: string,
    number_value: string,
    email: string,
    delivery_request_id?: string,
}

// платеж с новой карты,
// если есть оба входящих аргумента, то платеж проходит по апихе неавторизованного
// (функционал оплаты с помощью get-параметров адресной строки)
const newCardPayment = (
    {
        _agreement,
        deliveryRequestId = '',
    }: INewCardPayment,
) => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState): Promise<void> => {
        const state = getState();
        const {
            auth: { isAuth },
            city: { provider: { providerId } },
            payment: { paymentData: { email, isConnectAutoPay, agreement: stateAgreement, agreementEnc }, isSaveCard, result },
        } = getState();

        const cardPaymentSum = selectCardPaySum(state);

        const connectAutopay = isConnectAutoPay && !deliveryRequestId;
        const agreement = _agreement || stateAgreement;

        const requestParams = (isAuth && !(agreement || agreementEnc))
            ? <IAuthRequestParams>{
                save_card_flag: +isSaveCard,
                autopay_act: +connectAutopay,
                email: typeof email === 'string' ? email : email.value,
                payment_value: cardPaymentSum,
                payment_source: 1,
                return_url: location.origin + '/payments-response?',
            }
            : <IUnauthRequestParams>{
                agreement_enc: agreementEnc,
                number_value: agreement,
                email: typeof email === 'string' ? email : email.value,
                payment_value: cardPaymentSum,
                payment_source: 1,
                return_url: location.origin + '/payments-response?',
            };

        // Оплата заказа, подставляем delivery_request_id - для привязки оплаты к заказу
        if (deliveryRequestId) {
            requestParams.delivery_request_id = deliveryRequestId;
        }
        const auth = (agreement || agreementEnc) ? false : isAuth;
        const resp = await doRequest.apiPay<IRegPayCard>(
            auth
                ? makePaymentAuth(
                    providerId,
                    requestParams,
                )
                : makePaymentUnauth(
                    providerId,
                    requestParams,
                ),
        );
        if (resp.isSuccess) {
            const respData: IPaymentResult = {
                ...result,
                frameUrl: resp.payload.payUrl,
                queryAgreement: agreement || agreementEnc || '',
            };
            dispatch(setPaymentResult(respData));
        } else {
            captureException(resp);
        }
    };
};

export default newCardPayment;
